import React from 'react';

import classes from './Switch.module.scss';

const Switch = ({ checked, onChange }) => {
  return (
    <label className={classes.switch}>
      <input name='switch' type='checkbox' checked={checked} onChange={({ target: { checked } }) => onChange(checked)} />
      <span name='switch' className={`${classes.slider} ${classes.round}`} />
    </label>
  );
};

export default Switch;
